module.exports = __webpack_public_path__ + "static/caja_de_cambio_de_ruedas-6b7a45420d0c6db823ae0b40518eef26.png";